import { render, staticRenderFns } from "./deleteBlog.vue?vue&type=template&id=0844f3f0&scoped=true&lang=html&"
import script from "./deleteBlog.vue?vue&type=script&lang=js&"
export * from "./deleteBlog.vue?vue&type=script&lang=js&"
import style0 from "./deleteBlog.vue?vue&type=style&index=0&id=0844f3f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0844f3f0",
  null
  
)

export default component.exports